import { Model } from '@/models/Model';
import { SubColor } from './SubColor';

export class Color extends Model
{
  protected $name: string = 'Color';
  protected $endpoint: string = '/colors';
  protected $fillable: string[] = ['name', 'short_name', 'sub_colors'];

  public name?: string;
  public short_name?: string;
  public id?: string;
  public sub_colors?: SubColor[]

  protected static instance?: Color;
  public static getInstance(instance: Color) {
    if (! this.instance) {
      this.instance = instance;
    }

    return this.instance;
  }
}
